import styled from 'styled-components';

export const Wrapper = styled.div`
  bottom: 3rem;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  transition: transform .5s ease-in-out;
  -webkit-backface-visibility: hidden;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
`;

export const Plane = styled.div`
  cursor: grab;
  position: absolute;

  &.dragging {
    cursor: grabbing;
  }
`;



// WEBPACK FOOTER //
// ./src/components/IntroCloud/style.js